var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-6"},[_c('quill-editor',{staticClass:"quill-h200px",attrs:{"options":_vm.editorOption},model:{value:(_vm.mailMessage),callback:function ($$v) {_vm.mailMessage=$$v},expression:"mailMessage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }